export const BACK_URL_SERVICE = process.env.VUE_APP_BACK_SERVICE;
export const API_URL_SERVICE = process.env.VUE_APP_API_SERVICE;
export const BASE_PATH_APP = process.env.VUE_APP_BASE_PATH;
export const VERSION_APP = process.env.VUE_APP_VERSION;
export const APP_NAME = process.env.VUE_APP_NAME;
export const APP_PREFIX_AUTH = process.env.VUE_APP_PREFIX_AUTH
export const API_CEP = process.env.VUE_APP_API_BRASIL